import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { utils } from '../../helper/utils';
import {
  ContainerType,
  DMRLFilterGrid,
  EquipmentGroup,
  EquipmentManufacturer,
  EquipmentOwner,
  EquipmentReeferType,
  Profile,
} from '../../models/dmrl-filter.model';
import { DMRLHeader } from '../../models/dmrl-header.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DmrlService {
  filterData: DMRLFilterGrid = {};
  constructor(private readonly httpClient: HttpClient) {}

  getContainerMRL(appliedFilters: DMRLFilterGrid): Observable<DMRLHeader[]> {
    let equipmentIds = appliedFilters.containerNumbers ?? [];
    if (appliedFilters.searchText) {
      equipmentIds.push(appliedFilters.searchText);
    }
    if (equipmentIds.length == 0) {
      return of([]);
    }
    return this.httpClient.post<DMRLHeader[]>(environment.EQUIPMENT_MASTER_BASE_URL + 'equipment-details/dmrl', {
      equipmentNumbers: equipmentIds,
    });
  }
  getContainerMrlList(page: number, pageLimit: number, sort?: string, filters?: DMRLFilterGrid): Observable<HttpResponse<DMRLHeader[]>> {
    let url: string = `container-mrl/details?page=${page}&limit=${pageLimit}`;
    if (sort) {
      url += `&sort=${encodeURIComponent(sort)}`;
    }
    let clonedFilters = structuredClone(filters);

    return this.httpClient.post<DMRLHeader[]>(utils.GetUrlConfig(url), clonedFilters, { observe: 'response' }).pipe(
      map((response: HttpResponse<DMRLHeader[]>) => {
        const body = response.body;
        if (body) {
          const mappedBody = body.map((item, index) => ({
            ...item,
            id: index + 1,
            isSales: item.isSales ? 'Yes' : 'No',
            isSurplus: item.isSurplus ? 'Yes' : 'No',
            isEmpty: item.isEmpty ? 'Yes' : 'No',
          }));

          return new HttpResponse({
            body: mappedBody,
            headers: response.headers,
          });
        } else {
          return response;
        }
      }),
      catchError(() => {
        return of(new HttpResponse<DMRLHeader[]>({ body: [], headers: undefined }));
      }),
    );
  }
  getAllProfileList(): Observable<Profile[]> {
    return this.httpClient.get<Profile[]>(utils.GetUrlConfig('container-mrl/profiles'));
  }
  getAllEquipmentGroupList(): Observable<EquipmentGroup[]> {
    return this.httpClient.get<EquipmentGroup[]>(utils.GetUrlConfig('container-mrl/equipment-groups'));
  }
  getAllEquipmentOwnerList(): Observable<EquipmentOwner[]> {
    return this.httpClient.get<EquipmentOwner[]>(utils.GetUrlConfig('container-mrl/equipment-owners'));
  }
  getAllEquipmentManufacturerList(): Observable<EquipmentManufacturer[]> {
    return this.httpClient.get<EquipmentManufacturer[]>(utils.GetUrlConfig('container-mrl/equipment-manufacturers'));
  }
  getAllEquipmentReeferTypeList(): Observable<EquipmentReeferType[]> {
    return this.httpClient.get<EquipmentReeferType[]>(utils.GetUrlConfig('container-mrl/equipment-reefer-types'));
  }
  getAllContainerTypeList(): Observable<ContainerType[]> {
    return this.httpClient.get<ContainerType[]>(utils.GetUrlConfig('container-mrl/container-types'));
  }
  onDownload(filters: DMRLFilterGrid, sort?: string): Observable<HttpResponse<DMRLHeader[] | null>> {
    let url: string = `container-mrl/download`;
    if (sort) {
      url += `?sort=${encodeURIComponent(sort)}`;
    }
    let clonedFilters = structuredClone(filters);
    return this.httpClient.post<DMRLHeader[] | null>(utils.GetUrlConfig(url), clonedFilters, { observe: 'response' }).pipe(
      map((response: HttpResponse<DMRLHeader[] | null>) => {
        return response;
      }),
    );
  }
}
